import { AriaDatapoint } from '../datapoints/AriaDatapoint';
import { isFeatureEnabled } from 'owa-feature-flags';
import { trace } from 'owa-trace';

const emailRegex = new RegExp(/([a-zA-Z0-9+_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})/);
const ipRegex = new RegExp(
    /(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/
);
const htmlRegex = new RegExp(/<((div)|(span)|(table)|(ul)|(body))>/);

export function safeStringify(input: any): string {
    try {
        return JSON.stringify(input);
    } catch (e) {
        return e.message;
    }
}

export function validateString(value: string) {
    return testForPii(value) || value;
}

function testForPii(value: string): string {
    let errorMessage;
    if (emailRegex.test(value)) {
        errorMessage = ' contains an email address';
    } else if (ipRegex.test(value)) {
        errorMessage = ' contains an ip address';
    } else if (htmlRegex.test(value)) {
        errorMessage = ' contains html';
    }
    return errorMessage;
}

export function validatePropertyBag(datapoint: AriaDatapoint): string {
    if (isFeatureEnabled('fwk-turnOffCustomData')) {
        return 'emergency flight on';
    }

    if (datapoint.propertyBag) {
        var keys = Object.keys(datapoint.propertyBag);
        for (var ii = 0; ii < keys.length; ii++) {
            var propertyKey = keys[ii];
            var propertyValue = datapoint.propertyBag[propertyKey];
            var errorMessage = null;
            if (
                propertyKey.toLowerCase().indexOf('subject') > -1 &&
                typeof propertyValue == 'string'
            ) {
                errorMessage = "'s key contains subject";
            } else if (propertyValue) {
                errorMessage =
                    typeof propertyValue == 'object' && !(propertyValue instanceof Date)
                        ? ' is an object'
                        : testForPii(propertyValue.toString());
            }

            if (errorMessage) {
                trace.error(
                    propertyKey +
                        ' of datapoint ' +
                        datapoint.eventName +
                        errorMessage +
                        ' which is pii'
                );
                return errorMessage;
            }
        }
    }

    return safeStringify(datapoint.propertyBag);
}
